<template>
  <layout>
    <div class="w-full sm:w-1/2 mx-auto mb-0 mt-4 px-4 py-2 text-left">

      <h2
        class="text-2xl font-light leading-7 w-full text-gray-900 sm:text-2xl sm:leading-9 sm:truncate flex items-center justify-between">

        <div class="flex items-center">
          <Link :href="route('control-panel.index')">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
            stroke="currentColor" class="w-5 h-5 hover:text-markencode-blue mr-2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
          </svg>
          </Link>

          <p>Bestellungen</p>

        </div>


        <div class="flex"></div>
      </h2>
    </div>

    <div class="sm:w-1/2 mx-2 sm:mx-auto px-2 py-5 text-center">

      <table class="table-fixed min-w-full divide-y divide-gray-300 max-w-full">



        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="w-1/12 py-3.5 pl-1 pr-1 text-left text-xs font-semibold text-gray-900 sm:pl-3">
              Datum
            </th>

            <th scope="col" class="w-9/12 py-3.5 pl-1 pr-1 text-left text-xs font-semibold text-gray-900 sm:pl-3">
              Workshops/Umfragen
            </th>

            <th scope="col" class="w-1/12 py-3.5 pl-1 pr-1 text-left text-xs font-semibold text-gray-900 sm:pl-3">
              Preis
            </th>

            <th scope="col" class="w-1/12 pl-1 pr-2 py-3.5 text-center text-xs font-semibold text-gray-900 sm:pl-3">Status</th>
          </tr>
        </thead>
        <tbody class="bg-white">

          <tr v-if="!orders.length">
            <td colspan="4" class="text-sm text-gray-500 text-left px-3 py-2">Es liegen keine Bestellungen vor.
            </td>
          </tr>


          <tr v-for="(order, idx) in orders" :key="idx" class="even:bg-gray-50">

            <td class="w-1/12 py-4 pl-1 pr-1 sm:pl-3 align-top  text-sm font-medium text-gray-900">
              {{ order.created_at |
                formatDate }}
            </td>


            <td class="w-9/12 py-4 pl-1 pr-1 text-left align-top text-sm font-medium text-gray-900 sm:pl-3 min-w-0">
              <div v-if="order.order_sessions?.length > 0">
                <div v-for="(orderSession, idx1) in order.order_sessions" :key="idx1">
                  <div v-if="orderSession.markencode_sessions?.length > 0">
                    <div v-for="(markencodeSession, idx2) in orderSession.markencode_sessions" :key="idx2">
                      <p v-if="markencodeSession.customer_name">{{ markencodeSession.customer_name }}</p>

                      <p v-if="markencodeSession.project_name">{{ markencodeSession.project_name }}</p>

                      <p v-if="markencodeSession.brandname">{{ markencodeSession.brandname }}</p>

                      <p v-if="false && markencodeSession?.order_pricing?.total_price" class="whitespace-nowrap">{{ markencodeSession.order_pricing.total_price | formatEuroAmount }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </td>


            <td class="w-1/12 py-4 pl-1 pr-1 text-left align-top text-sm font-medium text-gray-900 sm:pl-3 min-w-0">
              <div v-if="order.order_sessions?.length > 0">
                <div v-for="(orderSession, idx1) in order.order_sessions" :key="idx1">
                  <div v-if="orderSession.markencode_sessions?.length > 0">
                    <div v-for="(markencodeSession, idx2) in orderSession.markencode_sessions" :key="idx2">

                      <p v-if="markencodeSession?.order_pricing?.total_price" class="whitespace-nowrap">{{ markencodeSession.order_pricing.total_price | formatEuroAmount }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </td>

            <td class="w-1/12  relative whitespace-nowrap align-top pl-1 pr-1 text-sm font-medium sm:pr-3 text-center">

              <div class="rounded-full mt-5 w-2 h-2 bg-markencode-yellow mx-auto animate-ping"></div>

            </td>
          </tr>
        </tbody>
      </table>

    </div>


  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';

export default {
  components: {
    Layout,
  },

  props: ['orders', 'translations'],

  data() {
    return {

    };
  },

  methods: {

  },
}
</script>